<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'collection',
  data() {
    return {}
  },
  created() {
  },
}
</script>
